var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editable-text',_vm._g(_vm._b({staticClass:"w-100",attrs:{"size":"small"},scopedSlots:_vm._u([{key:"default",fn:function({ value }){return [_c('div',{staticClass:"form-label"},[_vm._v(_vm._s(value))])]}}])},'editable-text',_vm.attrs,false),_vm.listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }